import React, { useState } from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";

export default function CancelSubModal({ cancelModal, fetchData, id }) {
  const [complete, setComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {user} = useAuthContext();

  const cancelSub = async () => {
    try {
      setIsLoading(true);
  
      const cancelSubResponse = await axios.delete(`${ApiConnectionString}/api/subscription/${id}`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
  
      if (cancelSubResponse.status === 200) {
        setComplete(true);
      }
    } catch (error) {
      console.error("Failed to cancel subscription:", error);
    } finally {
      setIsLoading(false);
    }
  };
 


  if (isLoading) {
    return (
      <div>
        <div className="send-modal-overlay">
          <div className="send-modal">
          <LoadingSpinner />
          </div>
         
        </div>
      </div>
    );
  } else if (complete) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Subscription Canceled</p>
          </div>
          <p>
            Your subscription has been successfully canceled. It will remain
            active until the end of the current billing period. Until then, you
            have the opportunity to renew it if you change your mind.
          </p>

          <div className="send-modal-footer">
            <button className="pointer cancelButton fw-bold mx-2 px-3" onClick={fetchData}>Close</button>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Cancel Subscription</p>
          </div>
          <p>Are you sure that you want to cancel this subscription?</p>

          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>

          <div className="send-modal-footer">
            <button className="saveChanges-button" onClick={cancelSub}>
              Cancel this subscription
            </button>
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
}
